import withStyles from '@material-ui/core/styles/withStyles';
import { default as React } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { question_types } from "redux/config"
import TextFormat from "@material-ui/icons/TextFormat";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControlLabel from '@material-ui/core/FormControlLabel';

import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Switch from "@material-ui/core/Switch";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem"
import Button from "components/CustomButtons/Button"
import CustomSelect from "components/CustomSelect/CustomSelect";
import commonStyle from "assets/jss/common/common";
import Age from "./components/Age"
import CheckBox from "./components/CheckBox"
import Dates from "./components/Dates"
import Gender from "./components/Gender"
import Nationality from "./components/Nationality"
import Number from "./components/Number"
import RadioButton from "./components/RadioButton"
import TextAnswer from "./components/TextAnswer"
import YesNo from "./components/YesNo"
import LogicRules from "./components/LogicRules"
import { api_url } from "redux/config.js";
import Toast from "views/Toast/Toast";
import uuid from 'uuidv4';
import { withTranslation } from 'react-i18next';
import { t } from 'i18next';

const styles = {
    ...commonStyle,
    footer: {
        borderTop: '1px solid;',
        borderColor: '#999999;',

        justifyContent: 'flex-end;'
    }
};
class Comonent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            survey_id: this.props.match.params.survey_id,
            sectionIndex: parseInt(this.props.match.params.section_index, 10),
            questionIndex: parseInt(this.props.match.params.question_index, 10),

            selected_question_type: 'checkbox',
            surveyQuestions: null,
            mainData: null,
            questionData: null,
            formData: {
                questionTitle: '',
                question: null,
                required: false,
                id: uuid()
            },
        }
        this.child = React.createRef();

    }
    componentDidMount() {
        this.onLoad()
    }

    onLoad = () => {
        let self = this;
        const id = this.state.survey_id;
        const url = api_url + `survey/get`;

        this.props.dispatch({ type: "LOAD_START" });
        axios({
            url,
            method: "get",
            params: {
                id: id
            },
            headers: {
                authorization: "Bearer ".concat(this.props.user.token)
            }
        })
            .then(function (response) {
                if (!response.data.success) {
                    Toast(400, response.data.error);
                } else {
                    self.setDefaultFormData(response.data.data)
                }
                self.props.dispatch({ type: "LOAD_END" });
            })
            .catch(function (errors) {
                console.info(errors);
                self.props.history.replace('/')
                self.props.dispatch({ type: "LOAD_END" });
                Toast(500);
            });
    };
    setDefaultFormData = (data) => {
        const { survey_id, sectionIndex, questionIndex, } = this.state
        const surveyQuestions = data.questions;
        const mainData = data.main
        if (questionIndex >= 0) {
            const questionLang = surveyQuestions.filter((item) => item.language === mainData.language)[0]
            let question = null
            if (questionLang) {
                question = questionLang.sections[sectionIndex].questions[questionIndex]

            } else {
                let questionLang = surveyQuestions[0]

                question = questionLang.sections[sectionIndex].questions[questionIndex]

            }
            this.setState({
                formData: question,
                selected_question_type: question.question.type,

                surveyQuestions,
                mainData,
            })
        } else {

            this.setState({
                surveyQuestions,
                mainData,
            })
        }
    }
    setFormData = (name, value) => {
        let formData = this.state.formData
        formData[name] = value
        this.setState({ formData })
    }
    // Jump targets for branching rules: every question (except the one being edited) and section
    // in the survey, plus "End of survey". Built from the primary language's structure; ids are
    // language-agnostic so the targets stay valid across translations.
    buildLogicTargets = () => {
        const { surveyQuestions, mainData, formData } = this.state
        if (!surveyQuestions || surveyQuestions.length === 0) return []
        const lang = (mainData && mainData.language) || surveyQuestions[0].language
        const qset = surveyQuestions.filter(q => q.language === lang)[0] || surveyQuestions[0]
        const targets = []
        ;(qset.sections || []).forEach((section, si) => {
            // The whole section (jumps to its first question) …
            targets.push({ value: 'section:' + si, label: `📂 ${t('Section')} ${si + 1}: ${section.sectionTitle || ''}` })
            // … then each question inside it, indented so it's clear you can target a specific one.
            ;(section.questions || []).forEach((q, qi) => {
                if (q.id === formData.id) return
                const title = q.questionTitle || `${t('Question')} ${qi + 1}`
                targets.push({ value: 'q:' + q.id, label: `   ↳ Q${si + 1}.${qi + 1}: ${title}` })
            })
        })
        targets.push({ value: 'END', label: `🏁 ${t('End of survey')}` })
        return targets
    }
    // ---- Per-question conditional visibility ("Show only if an earlier answer includes …") ----
    // Gate candidates = choice questions (checkbox/radio) that appear BEFORE this question in the
    // survey order (so the gate is always answered first). Stored on the question as
    // `visibility = { questionId, op:'includes'|'nincludes', values:[...] }`.
    buildVisibilityGates = () => {
        const { surveyQuestions, mainData, formData, sectionIndex, questionIndex } = this.state
        if (!surveyQuestions || !surveyQuestions.length) return []
        const lang = (mainData && mainData.language) || surveyQuestions[0].language
        const qset = surveyQuestions.filter(q => q.language === lang)[0] || surveyQuestions[0]
        const flat = []
        ;(qset.sections || []).forEach((section, si) => {
            (section.questions || []).forEach((q, qi) => flat.push({ si, qi, q }))
        })
        // Where does the current question sit? (a new question is appended to its section's end)
        let curIdx
        if (questionIndex >= 0) {
            const f = flat.findIndex(x => x.q.id === formData.id)
            curIdx = f >= 0 ? f : flat.filter(x => x.si <= sectionIndex).length
        } else {
            curIdx = flat.filter(x => x.si <= sectionIndex).length
        }
        const gates = []
        flat.forEach((x, idx) => {
            if (idx >= curIdx) return
            if (x.q.question && (x.q.question.type === 'checkbox' || x.q.question.type === 'radio')) {
                gates.push({ id: x.q.id, label: `Q${x.si + 1}.${x.qi + 1}: ${x.q.questionTitle || ''}`, q: x.q })
            }
        })
        return gates
    }

    optionsOfQuestionData = (q) => {
        const qq = (q && q.question) || {}
        if (qq.type === 'radio' && (qq.direction === '5star' || qq.direction === '10star')) {
            const n = qq.direction === '10star' ? 10 : 5, arr = []
            for (let v = 1; v <= n; v++) arr.push({ value: v, label: `${v} ★` })
            return arr
        }
        return (qq.options || []).map(o => ({ value: o.value, label: o.label }))
    }

    setQuestionVisibility = (visibility) => {
        const fd = { ...this.state.formData }
        if (visibility) fd.visibility = visibility
        else delete fd.visibility
        this.setState({ formData: fd })
    }

    renderQuestionVisibility = () => {
        const gates = this.buildVisibilityGates()
        if (!gates.length) return null
        const vis = this.state.formData.visibility || null
        const selectedGate = vis ? gates.find(g => g.id === vis.questionId) : null
        const valueOptions = selectedGate ? this.optionsOfQuestionData(selectedGate.q).map(o => ({ label: o.label, value: o.value })) : []
        const selectedValues = (vis && Array.isArray(vis.values)) ? vis.values.map(String) : []
        return (
            <div style={{ borderTop: '1px solid #eee', marginTop: 24, paddingTop: 16 }}>
                <h4 className={this.props.classes.noMargin}>{t('Show this question only if')} <span style={{ color: '#999', fontWeight: 'normal' }}>({t('optional')})</span></h4>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', background: '#f4f8f5', border: '1px solid #e2e8e4', borderRadius: 8, padding: '8px 12px', marginTop: 8 }}>
                    <span style={{ fontSize: 13, fontWeight: 600, color: '#5d6d66' }}>🔀 {t('Show only if:')}</span>
                    <div style={{ minWidth: 240 }}>
                        <CustomSelect isClearable placeholder={t('Question')}
                            value={selectedGate ? { label: selectedGate.label, value: selectedGate.id } : null}
                            onChange={(opt) => this.setQuestionVisibility(opt ? { questionId: opt.value, op: 'includes', values: [] } : null)}
                            options={gates.map(g => ({ label: g.label, value: g.id }))} />
                    </div>
                    {selectedGate &&
                        <>
                            <span style={{ fontSize: 13, color: '#8a988f' }}>{t('includes')}</span>
                            <div style={{ minWidth: 240 }}>
                                <CustomSelect isMulti placeholder={t('Answers')}
                                    value={valueOptions.filter(o => selectedValues.indexOf(String(o.value)) >= 0)}
                                    onChange={(vals) => this.setQuestionVisibility({ questionId: vis.questionId, op: 'includes', values: (vals || []).map(v => v.value) })}
                                    options={valueOptions} />
                            </div>
                            <Button size="sm" color="danger" onClick={() => this.setQuestionVisibility(null)}>✕</Button>
                        </>}
                </div>
            </div>
        )
    }

    // Current answer options of the question being edited (drives the rule value dropdown).
    // IMPORTANT: never call the child editor's getData() here — it validates and fires Toasts as
    // a side effect, which would spam on every render. Read options without side effects instead:
    // fixed-option types (yes/no, gender, age) come from the type schema; user-defined option
    // types (radio/checkbox) come from the saved question.
    currentQuestionOptions = () => {
        const type = this.state.selected_question_type
        const schema = question_types.filter(x => x.type === type)[0]
        if (schema && Array.isArray(schema.options) && schema.options.length > 0) return schema.options
        const q = this.state.formData.question
        return (q && Array.isArray(q.options)) ? q.options : []
    }
    renderQuestionType = () => {
        const { selected_question_type, formData } = this.state
        switch (selected_question_type) {
            case "checkbox":
                return <CheckBox onRef={ref => (this.child = ref)} question={formData.question} />
            case "radio":
                return <RadioButton onRef={ref => (this.child = ref)} question={formData.question} />
            case "text":
                return <TextAnswer onRef={ref => (this.child = ref)} question={formData.question} />
            case "age":
                return <Age onRef={ref => (this.child = ref)} question={formData.question} />
            case "date":
                return <Dates onRef={ref => (this.child = ref)} question={formData.question} />
            case "nation":
                return <Nationality onRef={ref => (this.child = ref)} question={formData.question} />
            case "gender":
                return <Gender onRef={ref => (this.child = ref)} question={formData.question} />
            case "yesno":
                return <YesNo onRef={ref => (this.child = ref)} question={formData.question} />
            case "number":
                return <Number onRef={ref => (this.child = ref)} question={formData.question} />
            default:
                return null
        }
    }
    onSave = () => {
        const { survey_id, sectionIndex, questionIndex } = this.state
        let formData = this.state.formData

        if (formData.questionTitle.length === 0) {
            Toast(400, t('Please insert question name')); return;
        }
        const question = this.child.getData()
        if (question) {
            formData.question = question
            // A question that drives branching must be answered (its answer picks the path),
            // so enforce required whenever it has logic rules.
            if (formData.logic && Array.isArray(formData.logic.rules) && formData.logic.rules.length > 0) {
                formData.required = true
            }
            const surveyQuestions = this.state.surveyQuestions
            const newSurveyQuestions = surveyQuestions.map((question) => {
                let sections = question.sections
                let section = sections[sectionIndex]
                if (questionIndex >= 0) {
                    section.questions[questionIndex] = formData
                } else {
                    section.questions.push(formData)
                }
                return {
                    language: question.language,
                    sections: sections
                }
            })
            this.setState({
                surveyQuestions: newSurveyQuestions
            }, () => this.updateSurveyQuestion(() => this.props.history.push(`/survey/edit/${survey_id}`)))
        }
    }

    updateSurveyQuestion = async (callback) => {
        const survey_id = this.state.survey_id
        const questions = this.state.surveyQuestions
        let formData = {
            id: survey_id,
            updateData: {
                questions: questions,
            }
        }
        console.info(formData)

        this.props.dispatch({ type: "LOAD_START" });
        const result = await axios({
            url: api_url + "survey/update",
            method: "post",
            headers: {
                authorization: "Bearer ".concat(this.props.user.token)
            },
            data: formData
        });
        this.props.dispatch({ type: "LOAD_END" });
        if (result.data.success) {
            callback()
            Toast(200, t('Updated successfully'));
        } else {
            Toast(400, result.data.error);
        }
    };
    onSaveAnother = () => {
        const { survey_id, sectionIndex, questionIndex } = this.state
        let formData = this.state.formData

        if (formData.questionTitle.length === 0) {
            Toast(400, t('Please insert question name')); return;
        }
        const question = this.child.getData()
        if (question) {
            formData.question = question
            // A question that drives branching must be answered (its answer picks the path),
            // so enforce required whenever it has logic rules.
            if (formData.logic && Array.isArray(formData.logic.rules) && formData.logic.rules.length > 0) {
                formData.required = true
            }
            const surveyQuestions = this.state.surveyQuestions
            const newSurveyQuestions = surveyQuestions.map((question) => {
                let sections = question.sections
                let section = sections[sectionIndex]
                if (questionIndex >= 0) {
                    section.questions[questionIndex] = formData
                } else {
                    section.questions.push(formData)
                }
                return {
                    language: question.language,
                    sections: sections
                }
            })
            this.setState({
                surveyQuestions: newSurveyQuestions
            }, () => this.updateSurveyQuestion(() => this.setState({
                selected_question_type: 'checkbox',
                formData: {
                    questionTitle: '',
                    question: null,
                    required: false,
                    id: uuid()
                }
            })))
        }
    }
    onCancel = () => {
        const { survey_id, sectionIndex, questionIndex } = this.state

        this.props.history.replace(`/survey/edit/${survey_id}`)
    }
    render() {
        const { classes } = this.props
        const { formData, selected_question_type, surveyQuestions, questionIndex } = this.state
        if (!surveyQuestions) return null
        return <div >
            <Card>
                <CardHeader
                    color="info"
                >
                    <h4 className={classes.noMargin}>{t('Add your question in section')}</h4>

                </CardHeader>
                <CardBody>

                    <CustomInput
                        id="email"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: e => this.setFormData('questionTitle', e.target.value),
                            startAdornment: (
                                <InputAdornment position="start">
                                    <TextFormat className={classes.inputAdornmentIcon} />
                                </InputAdornment>
                            ),
                            placeholder: t('Write Your Question Here'),
                            value: formData.questionTitle

                        }}
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={formData.required}
                                onChange={e => {
                                    this.setFormData('required', e.target.checked);
                                }}
                                value="checkedA"
                                color="primary"
                                classes={{
                                    switchBase: classes.switchBase,
                                    checked: classes.switchChecked,
                                    icon: classes.switchIcon,
                                    iconChecked: classes.switchIconChecked,
                                    bar: classes.switchBar
                                }}
                            />
                        }
                        label={t('This question is required?')}
                    />

                </CardBody>
            </Card>

            <Card>
                <CardHeader
                    color="info"
                >
                    <h4 className={classes.noMargin}>{t('Choose Type of Answer')}</h4>

                </CardHeader>
                <CardBody>
                    <GridContainer>
                        <GridItem xs={12} sm={2}>
                            {
                                question_types.map((item, key) => {
                                    return <div key={key}>
                                        <Button
                                            className={classes.justifyLeft}
                                            onClick={() => this.setState({ selected_question_type: item.type })}
                                            fullWidth
                                            color={item.type === selected_question_type ? 'info' : null}>{<item.icon />}{item.title}</Button>
                                    </div>
                                })
                            }
                        </GridItem>
                        <GridItem xs={12} sm={10}>
                            {this.renderQuestionType()}
                        </GridItem>
                    </GridContainer>

                    {this.renderQuestionVisibility()}

                    <div style={{ borderTop: '1px solid #eee', marginTop: 24, paddingTop: 16 }}>
                        <h4 className={classes.noMargin}>{t('Logic / Branching')} <span style={{ color: '#999', fontWeight: 'normal' }}>({t('optional')})</span></h4>
                        <LogicRules
                            questionType={selected_question_type}
                            currentOptions={this.currentQuestionOptions()}
                            targets={this.buildLogicTargets()}
                            value={formData.logic}
                            onChange={(logic) => {
                                this.setFormData('logic', logic)
                                // A branch question must be answered — reflect that on the required
                                // toggle the moment a rule is added.
                                if (logic && Array.isArray(logic.rules) && logic.rules.length > 0 && !this.state.formData.required) {
                                    this.setFormData('required', true)
                                }
                            }}
                        />
                    </div>

                </CardBody>
                <CardFooter className={classes.footer}>
                    <div>
                        <Button color="danger" onClick={() => this.onCancel()}>{t('Cancel')}</Button>
                        {questionIndex === -1 && <Button color="info" onClick={() => this.onSaveAnother()}>{t('Save and add another')}</Button>}
                        <Button color="success" onClick={() => this.onSave()}>{t('Save')}</Button>
                    </div>
                </CardFooter>
            </Card>
        </div>;
    }
}
const mapStatsToProps = ({ user }) => ({ user });
export default connect(mapStatsToProps)(
   withTranslation()(withStyles(styles, { withTheme: true })(Comonent))
);